import { HttpClient } from '@angular/common/http';
import { of, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var WikiService = /** @class */ (function () {
    function WikiService(http) {
        this.http = http;
        this.wikiCache = new Map();
    }
    WikiService.prototype.getWikiText = function (name, fromCache) {
        var _this = this;
        if (fromCache === void 0) { fromCache = true; }
        if (fromCache && this.wikiCache.has(name)) { // read from cache
            var description = this.wikiCache.get(name);
            return of(description);
        }
        else { // live request      
            return this.http.get("/search/wiki?name=" + name)
                .pipe(
            // get description
            map(function (response) { return response.description; }), 
            // special case: catch + cache 404
            catchError(function (err) { return err.status === 404 ? of('') : throwError(err); }), 
            // add cache entry
            tap(function (description) { return _this.wikiCache.set(name, description); }));
        }
    };
    WikiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WikiService_Factory() { return new WikiService(i0.ɵɵinject(i1.HttpClient)); }, token: WikiService, providedIn: "root" });
    return WikiService;
}());
export { WikiService };
